import { render, staticRenderFns } from "./Overtime.vue?vue&type=template&id=04bfd4c7&scoped=true"
import script from "./Overtime.vue?vue&type=script&lang=js"
export * from "./Overtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfd4c7",
  null
  
)

export default component.exports